<template>
  <div>
    <van-popup
      :value="visible"
      position="left"
      :get-container="getPopupContainer"
      :overlay="true"
      :lock-scroll="true"
      overlay-class="eni-menu-overlay"
      class="eni-menu-popup"
      @input="updateVisible"
    >
      <div class="eni-menu-panel">
        <div class="eni-menu-top">
          <div class="eni-menu-brand">
            <img class="eni-menu-logo" :src="logoImg" alt="logo" />
            <!-- <span class="eni-menu-brand-name">GEO</span> -->
          </div>

          <button class="eni-drawer-close" @click="closeDrawer" type="button">
            ✕
          </button>
        </div>

        <div class="eni-menu-section-title">
          {{ $t("headerMenuDrawer.navigation") }}
        </div>

        <div class="eni-menu-list">
          <div
            v-for="item in navList"
            :key="item.key"
            class="eni-menu-link"
            @click="navigate(item)"
          >
            <span class="eni-menu-link-text">{{ item.name }}</span>
            <span class="eni-menu-arrow">›</span>
          </div>
        </div>

        <div class="eni-menu-section-title eni-menu-section-title-lang">
          {{ $t("headerMenuDrawer.language") }}
        </div>

        <div class="eni-lang-card">
          <div class="eni-lang-box" @click="toggleLangExpand">
            <div class="eni-lang-left">
              <span class="eni-lang-label">
                {{ $t("headerMenuDrawer.currentLanguage") }}
              </span>
              <span class="eni-lang-text">{{ currentLocaleMeta.name }}</span>
            </div>
            <span
              class="eni-menu-arrow eni-lang-toggle"
              :class="{ 'is-open': langExpanded }"
            >
              ›
            </span>
          </div>

          <div v-show="langExpanded" class="eni-lang-options">
            <div
              v-for="item in langOptions"
              :key="item.code"
              class="eni-lang-option"
              :class="{ 'is-active': currentLangCode === item.code }"
              @click="selectLang(item)"
            >
              <div class="eni-lang-option-left">
                <span class="eni-lang-option-name">{{ item.name }}</span>
                <span class="eni-lang-option-badge">{{ item.badge }}</span>
              </div>
              <span v-if="currentLangCode === item.code" class="eni-lang-check">✓</span>
            </div>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { LOCALES, getLocaleMeta } from "@/i18n/localeMeta";

export default {
  name: "HeaderMenuDrawer",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    logoImg: {
      type: String,
      default: ""
    },
    navList: {
      type: Array,
      default() {
        return [];
      }
    },
    currentLangCode: {
      type: String,
      default: "en"
    }
  },
  data() {
    return {
      langExpanded: false,
      langOptions: LOCALES
    };
  },
  computed: {
    currentLocaleMeta() {
      return getLocaleMeta(this.currentLangCode);
    }
  },
  watch: {
    visible(val) {
      if (!val) {
        this.langExpanded = false;
      }
    }
  },
  methods: {
    getPopupContainer() {
      return document.body;
    },
    updateVisible(val) {
      this.$emit("update:visible", val);
    },
    closeDrawer() {
      this.$emit("update:visible", false);
    },
    navigate(item) {
      this.$emit("navigate", item);
    },
    toggleLangExpand() {
      this.langExpanded = !this.langExpanded;
    },
    selectLang(item) {
      this.$emit("change-lang", item);
      this.langExpanded = false;
    }
  }
};
</script>

<style lang="less">
.eni-menu-overlay {
  z-index: 5999 !important;
  background: rgba(15, 23, 42, 0.42) !important;
}

.eni-menu-popup {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  bottom: 0 !important;
  width: 82vw !important;
  max-width: 380px !important;
  height: 100vh !important;
  background: #ffffff !important;
  z-index: 6000 !important;
  overflow: hidden !important;
  transform: translate3d(0, 0, 0) !important;
}

.van-popup--left {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  bottom: 0 !important;
  height: 100vh !important;
  z-index: 6000 !important;
}

.eni-menu-panel {
  width: 100%;
  height: 100vh;
  min-height: 100vh;
  background: #ffffff !important;
  padding: 22px 18px 28px;
  box-sizing: border-box;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.eni-menu-panel,
.eni-menu-panel * {
  color: #1a2536 !important;
  opacity: 1 !important;
  visibility: visible !important;
  box-sizing: border-box;
}

.eni-menu-top {
  min-height: 44px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.eni-menu-brand {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.eni-menu-logo {
  width: 86px;
  height: 44px;
  object-fit: contain;
  display: block;
  flex-shrink: 0;
}

.eni-menu-brand-name {
  font-size: 20px;
  font-weight: 800;
  line-height: 1;
}

.eni-drawer-close {
  width: 38px;
  height: 38px;
  border: none;
  background: transparent;
  padding: 0;
  font-size: 24px;
  line-height: 1;
  color: #667897 !important;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
}

.eni-menu-section-title {
  margin-top: 28px;
  margin-bottom: 12px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.8px;
  text-transform: uppercase;
  color: #8b9ab2 !important;
}

.eni-menu-section-title-lang {
  margin-top: 26px;
}

.eni-menu-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.eni-menu-link {
  min-height: 54px;
  border: 1px solid #e7efff;
  background: linear-gradient(180deg, #fbfdff 0%, #f5f9ff 100%);
  border-radius: 16px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  cursor: pointer;
}

.eni-menu-link-text {
  font-size: 16px;
  font-weight: 700;
  line-height: 1.2;
}

.eni-menu-arrow {
  font-size: 20px;
  color: #8a98af !important;
  flex-shrink: 0;
  transition: transform 0.2s ease;
}

.eni-lang-card {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.eni-lang-box {
  min-height: 58px;
  border: 1px solid #e7efff;
  background: #f7faff;
  border-radius: 16px;
  padding: 10px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  cursor: pointer;
}

.eni-lang-left {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.eni-lang-label {
  font-size: 12px;
  font-weight: 600;
  color: #8b9ab2 !important;
  line-height: 1.2;
}

.eni-lang-text {
  font-size: 15px;
  font-weight: 700;
  line-height: 1.2;
}

.eni-lang-toggle.is-open {
  transform: rotate(90deg);
}

.eni-lang-options {
  border: 1px solid #e7efff;
  background: #ffffff;
  border-radius: 16px;
  overflow: hidden;
}

.eni-lang-option {
  min-height: 50px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  cursor: pointer;
  border-bottom: 1px solid #eef3fb;
}

.eni-lang-option:last-child {
  border-bottom: none;
}

.eni-lang-option.is-active {
  background: #f5f9ff;
}

.eni-lang-option-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.eni-lang-option-name {
  font-size: 15px;
  font-weight: 700;
  line-height: 1.2;
}

.eni-lang-option-badge {
  min-width: 28px;
  height: 20px;
  padding: 0 6px;
  border-radius: 999px;
  background: #eef4ff;
  color: #4b88ff !important;
  font-size: 12px;
  font-weight: 700;
  line-height: 20px;
  text-align: center;
}

.eni-lang-check {
  font-size: 16px;
  font-weight: 800;
  color: #4b88ff !important;
}

@media (max-width: 375px) {
  .eni-menu-popup {
    width: 84vw !important;
  }

  .eni-menu-panel {
    padding: 20px 16px 24px;
  }

  .eni-menu-brand-name {
    font-size: 18px;
  }

  .eni-menu-link-text,
  .eni-lang-option-name {
    font-size: 15px;
  }
}
</style>